import { createThunkEffect } from "../../utilities/ActionUtility";
import { requestApiKeysEffect, deleteApiKeyEffect, createApiKeyEffect } from "./ApiKeyEffect";

export const REQUEST_API_KEYS = "REQUEST_API_KEYS";
export const REQUEST_API_KEYS_FINISHED = "REQUEST_API_KEYS_FINISHED";

export const DELETE_API_KEY = "DELETE_API_KEY";
export const DELETE_API_KEY_FINISHED = "DELETE_API_KEY_FINISHED";

export const CREATE_API_KEY = "CREATE_API_KEY";
export const CREATE_API_KEY_FINISHED = "CREATE_API_KEY_FINISHED";

export const requestApiKeys = () => {
  return async dispatch => {
    return await createThunkEffect(dispatch, REQUEST_API_KEYS, requestApiKeysEffect);
  };
};

export const deleteApiKey = (keyId) => {
    return async dispatch => {
        return await createThunkEffect(dispatch, DELETE_API_KEY, deleteApiKeyEffect, keyId);
    };
};

export const createApiKey = () => {
  return async dispatch => {
    return await createThunkEffect(dispatch, CREATE_API_KEY, createApiKeyEffect);
  };
};
